<div class="table-container">
  <div class="data-card">
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>

        <!-- Version Grid Detail Row -->
        <ng-container matColumnDef="versionList">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                <div class="version-detail" [class.expanded]="row.id == expandedProductionRequest?.id">
                  @if(row.id == expandedProductionRequest?.id) {
                    <production-request-version-grid-component
                      #versionGrid
                      [parentRequest]="row"
                      style="width:100%;">
                    </production-request-version-grid-component>
                  }
                </div>
            </td>
        </ng-container>

        <!-- Request Id Column -->
        <ng-container matColumnDef="requestId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Request Id </th>
          <td mat-cell *matCellDef="let row"> 
            <span matRipple class="ref-code" [cdkCopyToClipboard]="formatRequestId(row.requestId)" (click)="onCopyToClipboard(formatRequestId(row.requestId))">{{formatRequestId(row.requestId)}}</span>
          </td>
        </ng-container>

        <!-- Client Column -->
        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Client </th>
          <td mat-cell *matCellDef="let row"> {{row.client}} </td>
        </ng-container>

        <!-- Name/Origin Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name/Origin </th>
          <td mat-cell *matCellDef="let row">
            {{row.name}} 
            <div class="cell-secondary">{{row.origin}}</div>
          </td>
        </ng-container>

        <!-- Sample/VO Column -->
        <ng-container matColumnDef="sampleVo">
          <th mat-header-cell *matHeaderCellDef>Req. </th>
          <td mat-cell *matCellDef="let row">
            <div style="display: flex; gap: 8px;">
              @if( row.requireSample ) {
                <i class="fa-solid fa-flask" matTooltip="Sample Required"></i>
              }
              @if( row.requireVoiceover ) {
                <i class="fa-solid fa-microphone" matTooltip="Voiceover Required"></i>
              }
            </div>
          </td>
        </ng-container>

        <!-- Air Date Column -->
        <ng-container matColumnDef="airDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Air Date </th>
          <td mat-cell *matCellDef="let row"> {{row.airDate | date:'d/M/yyyy'}} </td>
        </ng-container>

        <!-- Master Ref. Code Column -->
        <ng-container matColumnDef="masterRefCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Master Ref. Code </th>
          <td mat-cell *matCellDef="let row"> 
            <span matRipple [class.ref-code]="row.masterCommercialRefCode != null" [cdkCopyToClipboard]="row.masterCommercialRefCode" (click)="onCopyToClipboard(row.masterCommercialRefCode)">{{row.masterCommercialRefCode}}</span>
          </td>
        </ng-container>

        <!-- Master Brand/Product Column -->
        <ng-container matColumnDef="masterBrand">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Master Brand/Product </th>
          <td mat-cell *matCellDef="let row">  
            {{row.masterCommercialBrand}}
            <div class="cell-secondary">{{row.masterCommercialProduct}}</div>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell *matCellDef="let row">
            <span class="badge" [ngClass]="{
              'badge-new': row.status.id == 60,
              'badge-pending': row.status.id == 2,
              'badge-processing': row.status.id == 62 || row.status.id == 63,
              'badge-rejected': row.status.id == 4 || row.status.id == 7,
              'badge-reload': row.status.id == 5,
              'badge-approved': row.status.id == 6
            }">
              <span class="badge-dot"></span>
              {{row.status | objectdesc}}
            </span>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let row">
            <div class="actions">
              <button matButton class="act-btn" (click)="onViewHistory(row)" matTooltip="View History">
                <i class="fa-regular fa-message"></i>
              </button>
              @if( allowEditRequest ) {
                <button matButton class="act-btn" (click)="onEditRequest(row)" matTooltip="Edit Request">
                  <i class="fa-solid fa-pen"></i>
                </button>
              }
              @if( allowDeleteRequest(row) ) {
                <button matButton class="act-btn danger" (click)="onDeleteRequest(row)" matTooltip="Delete">
                  <i class="fa-regular fa-trash-can"></i>
                </button>
              }
              @if( allowEditRequest ) {
                <button matButton class="act-btn" (click)="onAddVersion(row)" matTooltip="Add Version to Request">
                  <i class="fa-solid fa-rectangle-ad"></i>
                </button>
              }
              @if( allowLinkMasterCommercial(row) ) {
                <button matButton class="act-btn" (click)="onLinkMasterCommercial(row)" matTooltip="Link Commercial to Request">
                  <i class="fa-solid fa-link"></i>
                </button>
              }
              <button matButton class="act-btn" (click)="onViewSamples(row)" matTooltip="View Request Samples">
                <i class="fa-solid fa-flask"></i>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="onExpandRequest(row)"></tr>
        <tr mat-row *matRowDef="let row; columns: ['versionList'];" class="version-detail-row"></tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      aria-label="Select page">
    </mat-paginator>
  </div>

  <button class="fab fab-left" (click)="onNewRequest()">
    <i class="fa-solid fa-plus"></i>
    New Request
  </button>
</div>
